const DEV = process.env.NODE_ENV === 'development';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import barba from '@barba/core';

gsap.registerPlugin(ScrollTrigger);


export default {
	init() {
		// JavaScript to be fired on all pages
		console.log('init common');
		
		let mm = gsap.matchMedia()

		// Mobile Header Scroll Logic (Vanilla JS)
		const header = document.querySelector('#masthead');
		let lastScrollTop = 0;

		if (header) {
			window.addEventListener('scroll', () => {
				if (window.innerWidth > 768) {
					header.style.transform = '';
					return;
				}

				const scrollTop = window.scrollY || document.documentElement.scrollTop;

				if (scrollTop > lastScrollTop && scrollTop > 0) {
					// Scrolling down
					header.style.transform = 'translateY(-100%)';
				} else {
					// Scrolling up
					header.style.transform = 'translateY(0)';
				}
				
				header.style.transition = 'transform 0.3s ease-out';
				lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
			}, { passive: true });
		}

		const logoText = document.querySelector('.logoText');
		if (logoText) {
			gsap.to(logoText, {
				y: -100,
				opacity: 0,
				scrollTrigger: {
					trigger: "body",
					start: "top top",
					end: "100px top",
					scrub: true
				}
			});
		}

		const voceMenu = document.querySelectorAll('.voceMenu');

		voceMenu.forEach((link)=>{
			link.addEventListener('click', ()=>{
				gsap.to(menu, {
					opacity: 0,
					height: 0,
					pointerEvents: 'none'
				})

				gsap.to(hamburger, {
					opacity: 1,
				})
			})
		})

		hamburger.addEventListener('click', ()=>{
			gsap.to(menu, {
				opacity: 1,
				height: '100%',
				pointerEvents: 'auto'
			}, '<')

			gsap.to(hamburger, {
				opacity: 0,
				
			})

		})

		closeHamburger.addEventListener('click', ()=>{

			gsap.to(menu, {
				opacity: 0,
				height: 0,
				pointerEvents: 'none'
			})

			gsap.to(hamburger, {
				opacity: 1,
			})
			

		})

	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		console.log('finalize common');
	},
};
